module.exports = __webpack_public_path__ + "static/media/cavalo.2af0f8bd.svg";